import { FC } from "react";
import { Link } from 'react-scroll'

interface ContactProps {}

const Contact: FC<ContactProps> = () => {
  return (
    <div
      className="bloc bloc-fill-screen d-bloc bloc-bg-texture texture-darken-strong"
      id="contact-section"
    >
      <div className="container">
        <div className="row">
          <div className="col text-md-left text-center">
            <div className="row scroll-fx-right-in">
              <div className="col scroll-fx-down-in col-lg-12">
                <h1 className="mg-md text-lg-center h1-about-style text-white text-white">
                  Contact Us
                </h1>
              </div>
            </div>
            <div className="row scroll-fx-right-in">
              <Link
                className="img-fluid rounded-circle mx-auto d-block scroll-fx-up-down mt-md-4 mt-sm-2"
                activeClass="active"
                to="home-section"
                spy={false}
                smooth={true}
                offset={0}
                duration={1000}
              >
                <img src="img/UAC_LOGO_transparent_small.png" alt="UAC Logo" />
              </Link>
            </div>
            <div
              className="row none animated zoomIn"
              data-appear-anim-style="zoomIn"
            >
              <div className="col">
                <h3 className="mg-md text-lg-center h3--linkedin-style">
                  <span className="fab fa-linkedin-in icon-md"></span>{' '}
                  <a
                    className="h3-8-style"
                    href="http://linkedin.com/in/jfpbeaulieu"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Linkedin
                  </a>
                </h3>
              </div>
              <div className="col">
                <h3 className="mg-md h3-8-style text-lg-center ">
                  <span className="fab fa-github icon-md"></span>{' '}
                  <a
                    className="h3-8-style"
                    href="https://github.com/JeffyJeff1980"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Github
                  </a>
                </h3>
              </div>
              <div className="col">
                <h3 className="mg-md h3-8-style text-lg-center ">
                  <span className="fab fa-stack-overflow icon-md"></span>{' '}
                  <a
                    className="h3-8-style"
                    href="http://stackoverflow.com/users/398499/jf-beaulieu?tab=profile"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Stack Overflow
                  </a>
                </h3>
              </div>
              <div className="col">
                <h3 className="mg-md h3-8-style text-lg-center ">
                  <span className="fab fa-medium icon-md"></span>{' '}
                  <a
                    className="h3-8-style"
                    href="https://medium.com/@JeffyJeff"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    Medium
                  </a>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
 
export default Contact;